// @Version: 1.0.0
export enum FIELUPLOAD_ERROR {
   AMOUNTTOBIG = 'AmountToBig',
   NOCHOICE = 'NoChoice',
   MAXSIZE = 'MaxSize',
   FILETYPE = 'FileType',
   REQUIRED = 'required',
   FILENAMEISINVALID = 'FilenameIsInvalid'
}

export enum UPLOAD_STATE {
   EMPTY = 0, // Typescript indexes automatically from the first one onward
   DISABLED, // All single states may be used to show or hide some icons, buttons...
   VALID,
   ERROR_MAX,
   ERROR_TYPE,
   ERROR_SIZE,
   ERROR_NO_CHOICE,
   ERROR_INVALID_FILENAME,
   REQUIRED
}
 
export enum FILE_LIST_POSITION {
   BOTTOM = 'bottom',
   TOP = 'top',
   LEFT = 'left',
   RIGHT = 'right'
}

export enum TRANSLATE_TEXTE {
   BUTTON = 'button',
   ICON = 'icon',
   TITLE = 'title',
   ERROR_AMOUNTTOBIG = 'error.amountToBig',
   ERROR_NOCHOICE = 'error.noChoice',
   ERROR_MAXSIZE = 'error.maxSize',
   ERROR_FILETYPE = 'error.fileType',
   ERROR_REQUIRED = 'error.required',
   ERROR_FILENAMEISINVALID = 'error.filenameIsInvalid'
}

export interface IFileResult {
   file: string;
   fileBlob: Blob;
   filename: string;
   size: number;
   fileExtension: string;
   lfnr: number; 
   openFile: () => void;
}
 
export interface ITranslateText {
   title: string;
   button: string;
   icon: string;
   amountToBig: string;
   noChoice: string;
   maxSize: string;
   fileType: string;
   required: string;
   filenameIsInvalid: string;
}